import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import RelatedGifts from '../RelatedGifts';
import { SiteSettingsContext } from '../../utils/context';

/**
 * Get array of bestseller gifts ids.
 */
const getBestSellerGifts = (productsInBasket, allProducts, countItems) => {
  const needArrayLength = countItems || 3;

  const idsProductsInBasket = productsInBasket.map((item) => item.id);
  // Filter products. Exclude custom product and products that already in the basket
  // and products without any category.
  const products = allProducts
    .filter((item) => !idsProductsInBasket.includes(item.id) && item.categoryIds.length > 0)
    .sort(
      (a, b) => a.fieldBestSellerWeight - b.fieldBestSellerWeight || a.fieldWeight - b.fieldWeight,
    );

  return products.slice(0, needArrayLength).map((item) => item.id);
};

const BestSellerGifts = () => {
  const settings = useContext(SiteSettingsContext);
  const gifts = useSelector((state) => state.productsStorage.gifts);
  const basketProducts = useSelector((state) => state.basket.products);
  const bestSellerGifts = getBestSellerGifts(basketProducts, Object.values(gifts));

  return (
    <RelatedGifts
      title={settings.basketPage.bestSellerGiftsTitle}
      productIds={bestSellerGifts}
      variant="bestsellers"
    />
  );
};

export default BestSellerGifts;
